import React, { Component } from 'react';

export class TermsOfUse extends Component {
    render() {
        return (
            <h1>Terms of use</h1>
        );
    }
}